var _circle, _circle2, _circle3, _circle4, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEykoHubs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 2,
    transform: "matrix(-1 0 0 1 3.669 12.947)",
    stroke: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 2,
    transform: "matrix(-1 0 0 1 12.83 12.523)",
    stroke: "currentColor"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 2,
    transform: "matrix(-1 0 0 1 2.5 4.5)",
    stroke: "currentColor"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 12.299 3.893)",
    stroke: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M10.348 6.215l-5.374 5.433M12.664 6.853l.224 3.625M9.265 4.597l-5.266.011"
  })));
}

export default SvgEykoHubs;